/**
 * The Concierge's public channels — the numbers the final design writes on the Central de
 * Informações, the help dialog and the legal pages. One place, so a new number is one change.
 */
export const CONCIERGE_WHATSAPP_HREF = "https://wa.me/5511945972753";
export const CONCIERGE_WHATSAPP_LABEL = "+55 (11) 94597-2753";
export const CONCIERGE_EMAIL = "atendimento@taniabulhoes.com.br";
